module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-07-d0143c0a0bb18024c3618c7b1ba8e975.png";